import watchNewFilterMonitoramentoNFeCompra from './saga/newFilter';
import watchNewFilterNextPageMonitoramentoNFeCompra from './saga/newFilterNextPage';
import watchImportarNotaEntrada from './saga/importarNotaEntrada';
import watchVisualizarNotaEntrada from './saga/visualizarNotaEntrada';
import watchDownloadZipMonitoramentoNFeCompra from './saga/downloadZip';

export const monitoramentoNFeCompraSaga = [
    watchNewFilterMonitoramentoNFeCompra(),
    watchNewFilterNextPageMonitoramentoNFeCompra(),
    watchImportarNotaEntrada(),
    watchVisualizarNotaEntrada(),
    watchDownloadZipMonitoramentoNFeCompra(),
]

export * from './actionTypes';
export * from './reducer';
export * from './service';
